import { onMounted, watch, computed } from "vue"
import { useStore } from "vuex"
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: "DonationReceiptOverlay",
    props: {
        readMoreUrl: {
            type: String,
            required: true
        }
    },
    setup(props){
        const store = useStore()
        const readMoreUrl = computed(() => props.readMoreUrl ?? store.state.main.page_overlay_content_data.readMoreUrl)

        let first,
            last,
            close

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        const cancelAction = function(){
            store.dispatch('main/closePageOverlay')
        }

        onMounted(() => {
            
            first = document.querySelector(
                '.kb-button[data-order="first"]'
            )
            last = document.querySelector(
                '.kb-button[data-order="last"]'
            )
            close = document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback(
                {
                    opening() {
                        first.focus()
                    }
                },
                { persistent: true }
            )

            const orderId = new URLSearchParams(document.location.search).get(
                'orderId'
            )
            if (orderId)
                store.dispatch('main/trackPurchaseData', { orderId })
        })

        return {
            readMoreUrl,
            cancelAction,
            tabTrap,
            getLabel: (labelKey) =>
                store.getters['labels/getLabel']({
                    labelCollection: 'DonationReceiptOverlay',
                    labelKey
                })
        }
    }
}